import logo from './logo.svg';
import './App.css';
import PrivacyPolicy from './pages/privacy';

function App() {
  return (
    <>
      <PrivacyPolicy />
    </>
  );
}

export default App;
